import React from 'react';

const FormGroup = ({ children }) => (
  <div className="form-group row">{children}</div>
);

export default FormGroup;
